'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'arrow-up';
var width = 448;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = ['', 'M426.4 192l-33.9 33.9-144-144 0 430.1-48 0 0-430.1-144 144-33.9-33.9 201.9-201.9 201.9 201.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;